/**
 * Snack notify recoil
 */

// Recoil
import { atom } from 'recoil';

// Utils
import { NotifyProps } from 'utils/types/atomTypes';

export const notifyAtom = atom<NotifyProps>({
  key: 'notifyAtom',
  default: {
    open: false,
    title: '',
    severity: 'success',
    handleClose: () => {},
  },
});
